import axios from 'axios';

/**
 *
 * @param companyId
 * @param programName
 */
export function getPaymentSystemsList(companyId, programName = null) {
  return axios({
    method: 'GET',
    url: '/api/payment-systems/list',
    params: {
      companyId: companyId,
      programName: programName,
    },
  });
}
